import React from 'react';
import PropTypes from 'prop-types';

const PaymentInput = ({ id, type, label, placeholder, aria_label, tab_index }) => {
    return (
        <>
            <label htmlFor={id}>{label}</label>
            <input
                id={id}
                type={type}
                placeholder={placeholder}
                aria-label={aria_label}
                // tabIndex={tab_index}
                readOnly
            />
        </>
    );
};
PaymentInput.propTypes = {
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    // name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
};
export default PaymentInput;
